import styled from 'styled-components';

export const ProductImageGalleryWrapper = styled.div`
  margin-bottom: 1rem;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    min-height: 484px;
  }

  .image-gallery-thumbnail {
    border-radius: 4px;
  }
  .image-gallery-thumbnail.active {
    border: 2px solid rgba(0, 0, 0, 0.94);
  }

  .image-gallery-thumbnail:hover {
    border: 2px solid rgba(0, 0, 0, 0.94);
  }

  .image-gallery-thumbnail-inner {
    margin: 0 auto;
  }

  .image-gallery-slide-wrapper {
    left: 10px;
  }
`;
